import React, { Component } from 'react';

import classes from './LoadingSpinner.module.css';
import { Spin } from 'antd';

class LoadingSpinner extends Component {
  render() {
    return (
      <div className={classes.container}>
        <Spin
          size="large"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10%"
          }} />
      </div>
    );
  }
}

export default React.memo(LoadingSpinner);
